import { FormCompletion } from "client/domain";

import { StepName, StepStatus } from "./Step";

export const barHeight = 250;

function hasCompletedBusinessDetails(
  formCompletionState: FormCompletion
): boolean {
  return (
    formCompletionState["companyInfoForm"] &&
    formCompletionState["storeDetailsForm"] &&
    formCompletionState["businessOwnerForm"]
  );
}
function hasCompletedPaymentInfo(formCompletionState: FormCompletion): boolean {
  return formCompletionState["bankForm"];
}
function hasCompletedCustomerService(
  formCompletionState: FormCompletion
): boolean {
  return formCompletionState["customerServiceForm"];
}

const formToPercentMap: Record<keyof FormCompletion, number> = {
  // represent the percent that each portion takes up
  bankForm: 49,
  businessOwnerForm: 16.7,
  cashPayForm: 0,
  cashPayAgreementAccepted: 0,
  companyInfoForm: 16.7,
  customerServiceForm: 1,
  storeDetailsForm: 16.7,
  storeForm: 0,
  agreementAccepted: 0,
  gatewayEnabled: 0,
};

export function getProgressPercentage(
  formCompletionState: FormCompletion
): number {
  let totalPercent = 0;
  const formKeys = Object.keys(formCompletionState);
  formKeys.forEach((formKey) => {
    if (formCompletionState[formKey as keyof FormCompletion]) {
      totalPercent += formToPercentMap[formKey as keyof FormCompletion];
    }
  });
  /**
   * Until salesforce data patch occurs, if a legacy merchant
   * has completed the MOP, storeForm will be complete but all others
   * will not be. This handles that edge case. This entire if block will
   * be removed after salesforce data patch.
   */
  if (
    !formCompletionState.companyInfoForm &&
    !formCompletionState.storeDetailsForm &&
    !formCompletionState.businessOwnerForm &&
    formCompletionState.storeForm
  ) {
    totalPercent +=
      formToPercentMap.companyInfoForm +
      formToPercentMap.storeDetailsForm +
      formToPercentMap.businessOwnerForm;
  }
  return totalPercent;
}

export function getStepStatus(
  formCompletionState: FormCompletion,
  stepLabel: StepName
): StepStatus {
  switch (stepLabel) {
    case "Business Details": {
      // because businessDetails is the first step, it's either COMPLETE or IN_PROGRESS and can't be NOT_STARTED
      if (!hasCompletedBusinessDetails(formCompletionState)) {
        return "inProgress";
      }
      return "complete";
    }
    case "Payment Information": {
      if (hasCompletedPaymentInfo(formCompletionState)) {
        return "complete";
      }
      if (hasCompletedBusinessDetails(formCompletionState)) {
        return "inProgress";
      }
      return "notStarted";
    }
    case "Customer Service": {
      if (hasCompletedCustomerService(formCompletionState)) {
        return "complete";
      }
      if (hasCompletedPaymentInfo(formCompletionState)) {
        return "inProgress";
      }
      return "notStarted";
    }
    default:
      return "notStarted";
  }
}
